<script>
    import { openSignup10 } from "#lib/stores/signup10.js";
    import { userCountryStore } from "#lib/stores/countryStore.js";
    import { campaign } from "#lib/stores/campaign.js";
    import { rewardLabel } from "#lib/campaign.js";

    // Footer newsletter opens the same €10 survey modal as the top bar
    // (rendered once in +layout.svelte), so every signup runs through one flow.
    function openSignup() {
        openSignup10("footer");
    }
    import CookieBanner from "#lib/components/ui/CookieBanner.svelte";
    import { onMount } from "svelte";
    import { browser } from "$app/environment";
    import { marketingConsentStore } from "#lib/stores.js";

    let metricoolLoaded = false;
    // Non-auto-showing banner instance so the "Your Privacy Choices" link can
    // re-open cookie/marketing preferences (the passive opt-out US visitors
    // get instead of a popup). autoShow={false} = never first-visit shows.
    let cookieBannerRef;

    function loadMetricool() {
      if (!browser || metricoolLoaded) return;
      metricoolLoaded = true;

      const existing = document.querySelector('script[data-metricool="be.js"]');
      if (existing) return;

      const script = document.createElement("script");
      script.type = "text/javascript";
      script.src = "https://tracker.metricool.com/resources/be.js";
      script.async = true;
      script.dataset.metricool = "be.js";

      script.onload = () => {
        try {
          // beTracker is provided by the Metricool script
          window.beTracker?.t({ hash: "2185b0560f97a2966e3283dd54923390" });
        } catch (e) {
          // ignore
        }
      };

      document.head.appendChild(script);
    }

    onMount(() => {
      if (browser && localStorage.getItem("marketing") === "true") {
        loadMetricool();
      }
    });

    $: if (browser && $marketingConsentStore) {
      loadMetricool();
    }

   
</script>

<footer class="flex-column">
  <div class="footer-content">
    <div class="signup-wrapper">
      <h2>Join our newsletter</h2>
      <p>
        Stay in the loop! Join our newsletter for updates, exclusive offers, and
        the latest on GLORB
      </p>

      <!-- Same words as every other way into the survey (hub ledger 092). -->
      <button type="button" class="newsletter-cta" on:click={openSignup} data-testid="signup10-footer">
        Get {rewardLabel($campaign, $userCountryStore)} off →
      </button>
    </div>
    <nav>
    <div class="footer-nav-row">
      <div class="footer-nav-row-left">
        <p>Follow us</p>
      </div>
      <div class="footer-nav-row-right">
        <a href="https://www.facebook.com/glorblight/">Facebook</a>
        <a href="https://www.pinterest.com/glorb_light/_created/">Pinterest</a>
        <a href="https://www.instagram.com/glorb_light/">Instagram</a>
      </div>
    </div>
    <div class="footer-nav-row">
      <div class="footer-nav-row-left">
        <p>Company</p>
      </div>
      <div class="footer-nav-row-right">
        <a href="/faq/">Faqs</a>
        <a href="/about/">Mission & Culture</a>
        <a href="/contact/">Contact</a>
        <!-- <a href="/press">Press</a> -->
      </div>
    </div>
    <div class="footer-nav-row">
      <div class="footer-nav-row-left">
        <p>Policies</p>
      </div>
      <div class="footer-nav-row-right">
        <a href="/policies/privacy-policy/">Privacy Policy</a>
        <a href="/policies/refund-policy/">Return & Refund Policy</a>
        <a href="/policies/terms-of-service/">Terms of service</a>
        <a href="/policies/warranty-policy/">Warranty Policy</a>
        <a href="/policies/shipping-policy/">Shipping Policy</a>
        <a href="/policies/cookies/">Cookies</a>
        <button
          type="button"
          class="privacy-choices-link"
          on:click={() => cookieBannerRef?.toggleBanner()}
        >
          Your Privacy Choices
        </button>
      </div>
    </div>
    </nav>
  </div>
  <div class="snrgy-div">
    <p>SNRGY Studios AB</p>
    <p>Norra Allégatan 1, 413 30, Göteborg.</p>
    <p>Registration number: 559481-0466.</p>
    <p>Contact: <a href="mailto: support@glorb.me">support@glorb.me</a></p>
  </div>

<!--Gorgias Chat Widget loaded via layout onMount-->

<!--Bundle Start-->
<script src="https://bundle.dyn-rev.app/loader.js?g_cvt_id=2e1976a8-4bb9-43bd-b03a-2d2c0cd30c06" async></script>
<!--Bundle End-->
</footer>

<CookieBanner bind:this={cookieBannerRef} autoShow={false} />

<style lang="scss">
  footer {
    padding: 4rem var(--padding) 4rem var(--padding);
    justify-content: space-around;
    background-color: var(--secondary-color);
    color: var(--primary-color);
    position: relative;

    h2 {
      font-size: 50px;
      max-width: 13rem;
      padding-bottom: var(--gutter);
      line-height: 50px;
      font-family: "Montreal light";
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;
    }

    .signup-wrapper p {
      font-size: 14px;
    }

    .newsletter-cta {
      margin-top: 1.25rem;
      height: 40px;
      width: 12rem;
      background-color: transparent;
      color: white;
      border: white 1px solid;
      font: inherit;
      font-size: 14px;
      cursor: pointer;
      transition: background-color 0.15s, color 0.15s;

      &:hover {
        background-color: white;
        color: #000;
      }
    }
    .footer-nav-row {
      margin-top: 2rem;
      display: grid;
      grid-template-columns: 1fr 1fr;

      p,
      a {
        font-size: 16px;
        font-family: "Whyte regular";
      }

    

      a {
        margin-bottom: 0.75rem;
        display: inline-block;
      }
    }
    .footer-nav-row-right {
      display: flex;
      flex-direction: column;
    }

    a {
      text-transform: uppercase;
    }
    /* "Your Privacy Choices" is a button (it opens a dialog, not a page) but
       must read as a footer link sibling. */
    .privacy-choices-link {
      margin-bottom: 0.75rem;
      display: inline-block;
      padding: 0;
      background: none;
      border: none;
      cursor: pointer;
      text-align: left;
      text-transform: uppercase;
      font-size: 16px;
      font-family: "Whyte regular";
      color: inherit;
    }
    .privacy-choices-link:hover {
      text-decoration: underline;
    }
    .snrgy-div {
        margin-top: 2rem;
        font-size: 14px;
        font-size:14px;

        p, a {
          font-size:14px;
          color: #8c8787;
        }
 
        a {
          text-transform: none;
          color: rgb(219, 255, 228)
        }
      }
    nav {
      p {
        text-transform: uppercase;
      }

      a:hover {
        text-decoration: underline;
      }
    }
  }

  .footer-nav-row:first-child {
    padding-top: var(--margin-big);
  }

  @media (max-width: 400px) {
    footer {
      justify-content: flex-start;
    }
  }

  @media (min-width: 1000px) {
    footer {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      padding: 8rem 4rem 8rem 4rem;
      /* padding: 8rem calc(var(--padding) * 4); */

      h2 {
        max-width: 100%;
        font-size: 80px;
        line-height: 80px;
      }

      .footer-content {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
      }

      .snrgy-div {
        margin-top: 2rem;
        font-size: 14px;
        align-self: flex-start;

      
      }

      nav {
        display: flex;
        flex-direction: row;
        justify-content: space-evenly;
        gap: 4rem;
        a:hover {
          color: orange;
        }
      }

      .footer-nav-row {
        display: flex;
        flex-direction: column;
        margin-top: 0px;

        p {
          margin-bottom: var(--gutter);
        }
      }

      .footer-nav-row-left {
        p {
          font-size: 20px;
        }
      }

      .footer-nav-row-right {
        a {
          font-size: 14px;
        }
      }

      .signup-wrapper {
        max-width: 30rem;
        width: 100%;

        p {
          max-width: 26rem;
        }
      }
    }
    .footer-nav-row:first-child {
      padding-top: 0;
    }
  }

  @media (min-width: 1300px) {

    footer {

    
    .signup-wrapper {
        max-width: 40rem;
        width: 100%;

        p {
          max-width: 26rem;
        }
      }
    }
    }
</style>

